import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <h1>Weather App</h1>
      <Weather />
      <footer>
        This project was coded by{" "}
        <a
          href="https://sprightly-cheesecake-95d94f.netlify.app"
          target="_blank"
          rel="noreferrer"
        >
          Valentyna Pliushch
        </a>{" "}
        and is{" "}
        <a
          href="https://github.com/valentynaPliushch/weather_app_week_6"
          target="_blank"
          rel="noreferrer"
        >
          open-sources on Github
        </a>
      </footer>
    </div>
  );
}

export default App;
